import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  educationDegrees: [],
  allEducationDegrees: [],
  totalPages: 0,
  totalRecords: 0,
  educationDegree: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_26: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_EducationDegrees(state, educationDegrees) {
    state.educationDegrees = educationDegrees.items;
    state.totalPages = educationDegrees.totalPages;
    state.totalRecords = educationDegrees?.totalRecords ?? 0;
  },
  SET_AllEducationDegrees(state, educationDegrees) {
    state.allEducationDegrees = educationDegrees;
  },
  SET_EducationDegree(state, educationDegree) {
    state.educationDegree = educationDegree;
  },
};
const actions = {
  errorEducationDegree({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllEducationDegrees({ commit, dispatch, rootState }) {
    return apiClient
      .get('/EducationDegrees/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllEducationDegrees', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorEducationDegree', error);
      });
  },
  addEducationDegree({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/EducationDegrees', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorEducationDegree', error);
      });
  },
  getEducationDegree({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/EducationDegrees/ById?educationDegreeId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_EducationDegree', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorEducationDegree', error);
      });
  },
  editEducationDegree({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/EducationDegrees/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorEducationDegree', error);
      });
  },
  deleteEducationDegree({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/EducationDegrees/Remove?educationDegreeId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorEducationDegree', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
